export default "__VITE_ASSET__DXnrvep1__"